// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getBloodSugarsPending: false,
  getBloodSugarsError: null,
  getWeighingsPending: true,
  getWeighingsError: null,
  getWeighingStatsPending: false,
  getWeighingStatsError: null,
  weighingStats: {
    kg: 0,
    percentage: 0,
  },
  getSentimentAnalysisPending: false,
  getSentimentAnalysisError: null,
  loading: false,
  error: null,
  emotional_wellbeings: [],
  productivity_scores: [],
  resilience_scores: [],
  empathy_scores: [],
  blood_sugars: [],
  getWaistlinesPending: true,
  getWaistlinesError: null,
  waistlines: [],
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/progress/redux/initialState.js